(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["premium_video_hero"] && !Shopify.designMode) return;
  try {
    
/* Runs on every “Premium Video Hero” section — ES5 compatible */
; (function () {

  // Respect reduced motion (safe on ES5 engines)
  var prefersReduced = false;
  try {
    prefersReduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch (e) {}

  // Utility: iterate NodeList in ES5
  function each(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }

  // Utility: add/remove "active" on dots
  function setActiveDot(dots, activeIndex) {
    for (var i = 0; i < dots.length; i++) {
      if (i === activeIndex) {
        if (dots[i].classList) dots[i].classList.add('active');
        else dots[i].className += ' active';
      } else {
        if (dots[i].classList) dots[i].classList.remove('active');
        else dots[i].className = dots[i].className.replace(/\bactive\b/, '');
      }
    }
  }

  // Scramble helpers
  function prime(el) {
    if (!el.getAttribute('data-final')) {
      el.setAttribute('data-final', (el.textContent || el.innerText || '').replace(/\s+$/,''));
    }
    if (prefersReduced) {
      el.textContent = el.getAttribute('data-final');
      return;
    }
    el.textContent = el.getAttribute('data-final').replace(/\d/g, '0');
  }

  function scramble(el) {
    if (el.getAttribute('data-cooldown') === '1') return;
    el.setAttribute('data-cooldown', '1');

    var final = el.getAttribute('data-final');
    if (prefersReduced) {
      el.textContent = final;
      el.setAttribute('data-cooldown', '0');
      return;
    }

    var duration = 1000; // 1s
    var fps = 40;
    var stepMs = 1000 / fps;
    var steps = Math.round(duration / stepMs);
    var frame = 0;

    var tick = setInterval(function () {
      el.textContent = final.replace(/\d/g, function () { return Math.floor(Math.random() * 10); });
      frame++;
      if (frame >= steps) {
        clearInterval(tick);
        el.textContent = final;
        setTimeout(function(){ el.setAttribute('data-cooldown', '0'); }, 100);
      }
    }, stepMs);
  }

  // For every section
  var sections = document.querySelectorAll('[data-section-type="premium_video_hero"]');
  each(sections, function (section) {

    /* ---------- testimonial slider (seamless loop) ---------- */
    var wrap = section.querySelector('.testimonials');
    if (wrap) {
      var track = wrap.querySelector('.track');
      var dots  = wrap.querySelectorAll('.dot');

      // Read interval from data attribute; default 5000ms
      var autoMs = parseInt(wrap.getAttribute('data-auto'), 10);
      if (isNaN(autoMs) || autoMs < 0) { autoMs = 5000; }

      // Helper: NodeList -> Array (ES5)
      function toArray(list){ var a=[]; for (var i=0;i<list.length;i++) a.push(list[i]); return a; }

      var originals = toArray(track.querySelectorAll('.slide'));
      var count = originals.length;

      // If only 1 slide, nothing to loop
      if (count <= 1) { 
        // still ensure active dot state
        if (dots.length) { setActiveDot(dots, 0); }
        return; 
      }

      // Clone last->front and first->end for seamless loop
      var firstClone = originals[0].cloneNode(true);
      var lastClone  = originals[count - 1].cloneNode(true);
      track.insertBefore(lastClone, originals[0]);
      track.appendChild(firstClone);

      // Index starts at first real slide (1) because 0 is lastClone
      var idx = 1;

      // Transition helpers
      function setTransform() {
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      }
      function enableTransition() {
        track.style.transition = 'transform var(--slide-speed) ease';
      }
      function disableTransition() {
        track.style.transition = 'none';
      }
      function goTo(i, animate) {
        idx = i;
        if (animate) { enableTransition(); }
        else { disableTransition(); }
        setTransform();
        // Force reflow if we disabled transition to ensure the next enable works
        if (!animate) { track.offsetHeight; }
        // Update dots to real index
        setActiveDot(dots, (idx - 1 + count) % count);
      }

      // Initial position: snap to idx=1 without animation
      disableTransition();
      setTransform();
      track.offsetHeight; // reflow
      enableTransition();
      setActiveDot(dots, 0);

      // Handle wrap-around snaps after transitions
      track.addEventListener('transitionend', function () {
        // If we've moved onto the appended firstClone (index = count + 1), snap to real first (1)
        if (idx === count + 1) {
          goTo(1, false); // snap without animation
        }
        // If we've moved onto the prepended lastClone (index = 0), snap to real last (count)
        else if (idx === 0) {
          goTo(count, false);
        }
      });

      // Dot navigation -> go to real slide (offset by +1 because of leading clone)
      for (var i = 0; i < dots.length; i++) {
        (function(iFixed){
          dots[iFixed].addEventListener('click', function () {
            goTo(iFixed + 1, true);
          });
        })(i);
      }

      // Auto-play (always advances forward -> right-to-left visual movement)
      var auto = null;
      function startAuto() {
        if (dots.length > 1 && autoMs > 0) {
          stopAuto();
          auto = setInterval(function () {
            goTo(idx + 1, true);
          }, autoMs);
        }
      }
      function stopAuto() { if (auto) { clearInterval(auto); auto = null; } }

      startAuto();
      wrap.addEventListener('mouseenter', stopAuto);
      wrap.addEventListener('mouseleave', startAuto);
    }

    /* ---------- stats scramble animation (re-run on each view) ---------- */
    var sectionNums = section.querySelectorAll('.stat__num');
    if (!sectionNums.length) return;

    // Initial prime
    each(sectionNums, prime);

    // Observer path
    if (typeof window.IntersectionObserver === 'function') {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            each(sectionNums, scramble);
          } else if (entry.intersectionRatio === 0) {
            // Fully out of view -> reset to zeros (unless reduced motion)
            each(sectionNums, function (el) {
              if (prefersReduced) { el.textContent = el.getAttribute('data-final'); return; }
              prime(el);
              el.setAttribute('data-cooldown', '0');
            });
          }
        }
      }, { threshold: [0, 0.5], rootMargin: '0px 0px -10% 0px' });

      io.observe(section);
    } else {
      // Fallback: manual viewport checks
      var wasIn = false;
      function inView() {
        var r = section.getBoundingClientRect();
        return r.top < window.innerHeight * 0.6 && r.bottom > window.innerHeight * 0.4;
      }
      function onScroll() {
        var nowIn = inView();
        if (nowIn && !wasIn) each(sectionNums, scramble);
        if (!nowIn && wasIn && !prefersReduced) each(sectionNums, function (el) { prime(el); el.setAttribute('data-cooldown','0'); });
        wasIn = nowIn;
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

  });

})();

  } catch(e) { console.error(e); }
})();
})();
